import { defineMessages, MessageDescriptor } from 'react-intl';

export interface SignUpFormState {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  role: string;
  password: string;
  callingCode: string;
}

export const errorMessages = defineMessages({
  blockedEmailDomain: {
    id: 'text-this-email-domain-is-blocked',
    defaultMessage:
      'This email domain is blocked by Glints. Reach out to Contact Support for help.',
  },
  emailAlreadyTaken: {
    id: 'text-email-has-been-taken',
    defaultMessage: 'This email has been taken',
  },
  somethingWentWrong: {
    id: 'text-something-went-wrong',
    defaultMessage: 'Something went wrong. Please try again later.',
  },
});

export const COMPANY_SIZES = {
  SELF_EMPLOYED: 'SELF_EMPLOYED',
  BETWEEN_1_AND_10: 'BETWEEN_1_AND_10',
  BETWEEN_11_AND_50: 'BETWEEN_11_AND_50',
  BETWEEN_51_AND_200: 'BETWEEN_51_AND_200',
  BETWEEN_201_AND_500: 'BETWEEN_201_AND_500',
  BETWEEN_501_AND_1000: 'BETWEEN_501_AND_1000',
  BETWEEN_1001_AND_5000: 'BETWEEN_1001_AND_5000',
  BETWEEN_5001_AND_10000: 'BETWEEN_5001_AND_10000',
  MORE_THAN_10000: 'MORE_THAN_10000',
};

export type CompanySize = keyof typeof COMPANY_SIZES;

type CompanySizeMessageParams = {
  minHeadcount?: number;
  maxHeadcount?: number;
};

export const getCompanySizeMessageDescriptor = (
  companySize?: CompanySize
): [MessageDescriptor, CompanySizeMessageParams] => {
  if (companySize === COMPANY_SIZES.SELF_EMPLOYED) {
    return [
      {
        id: 'interactive-self-employed',
        defaultMessage: 'Self Employed',
      },
      {},
    ];
  } else if (companySize === COMPANY_SIZES.MORE_THAN_10000) {
    return [
      {
        id: 'interactive-more-than-employees',
        defaultMessage: '{minHeadcount}+ employees',
      },
      {
        minHeadcount: Number(companySize?.split('_')[2]),
      },
    ];
  } else {
    return [
      {
        id: 'interactive-headcount-number-employees',
        defaultMessage: '{minHeadcount} - {maxHeadcount} employees',
      },
      {
        minHeadcount: Number(companySize?.split('_')[1]),
        maxHeadcount: Number(companySize?.split('_')[3]),
      },
    ];
  }
};
